<input
  name="googleplacessearch"
  [class]="'googleplacessearch' + (isLoading() ? ' loading' : '')"
  pInputText
  type="text"
  #addrInput
  [placeholder]="isLoading() ? 'Lade Google Maps...' : (hasError() ? 'Fehler beim Laden' : 'Adresse eingeben')"
  autocomplete="off"
  variant="filled"
  [disabled]="isLoading() || hasError()"
/>
